import gql from 'graphql-tag';
import legacyOrderFragment from './legacyOrderFragment.gql';
import itemFragment from './itemFragment.gql';

export default gql`
  fragment ordersWrapperFragment on OrdersWrapper {
    id
    number
    coupon_code
    sealed
    exchange_rate_value
    currency_code
    eligible_for_cashback
    cashback_percentage
    isPrime
    applicable_promotions {
      name
      name_ar
      type
      coupon_code
      expiry_days
      expiry_hours
      expiry_minutes
      customs_percent
      shipping_percent
      fees_percent
      clearance_percent
      cashback_percent
      total_price
      total_cashback
      recommended
    }
    applicable_subscriptions {
      name
      name_ar
      type
      coupon_code
      customs_percent
      shipping_percent
      fees_percent
      clearance_percent
      cashback_percent
      total_price
      total_cashback
      subscription_fee
      recommended
    }
    legacy_orders {
      ...legacyOrderFragment
    }
    saved_items {
      ...itemFragment
    }
    shipping_method {
      id
      shipping_type {
        id
        type {
          name
          name_ar
        }
      }
      ship_address {
        id
        city {
          id
        }
        phone_number {
          number
        }
      }
    }
    in_usd {
      total_customs
      total_tax
      total_clearance_charges
      shipping_intl
      shipping_us
      subtotal
      delivery_fee
      payment_fee
      total_promotions
      total_adjustments
      total_price
      grand_total
      total_items
      fees
      total_amount_due
    }
    in_currency {
      total_customs
      total_tax
      total_clearance_charges
      shipping_intl
      shipping_us
      subtotal
      delivery_fee
      payment_fee
      total_promotions
      total_adjustments
      total_price
      grand_total
      total_items
      fees
      total_amount_due
      total_cashback
    }
    subscriptionFee
  }
  ${legacyOrderFragment}
  ${itemFragment}
`;



// WEBPACK FOOTER //
// ./app/containers/LegacyCartPage/graphql/ordersWrapperFragment.gql.js